/**
 * Timestamps from the API.
 *
 * The backend stores every timestamp as a naive UTC `DateTime` (`datetime.utcnow`), so it
 * serializes them without a timezone: `"2026-09-22T11:30:00"`. `new Date()` reads a
 * date-time in that form as *local* time, which silently shifts every timestamp by the
 * viewer's UTC offset - three hours for most of our users. That is merely wrong for a
 * clock time and worse for a date, because a message sent late in the evening lands under
 * the wrong day heading. `parseServerDate` appends the `Z` the server omits.
 */

const HAS_TIMEZONE = /[zZ]|[+-]\d\d:?\d\d$/;

export const parseServerDate = (value?: string | null): Date | null => {
    if (!value) return null;
    const normalized = HAS_TIMEZONE.test(value) ? value : `${value}Z`;
    const parsed = new Date(normalized);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};
